export const TARIFAS_VENTA_REQUEST = "TARIFAS_VENTA_REQUEST";
export const TARIFAS_VENTA_OK = "TARIFAS_VENTA_OK";
export const TARIFAS_VENTA_ERROR = "TARIFAS_VENTA_ERROR";
